import LogoIcon from "../icons/Logo";
import { Button } from "@bravedigital/goodnature-ui";

export const CustomErrorView = () => {
  console.error("🔴 Error view rendered");

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="absolute top-0 left-0 h-full w-full grow overflow-x-hidden">
      <a
        href="/"
        className="absolute top-0 left-1/2 z-30 -translate-x-1/2 py-[30px]"
      >
        <LogoIcon flip={true} />
      </a>
      <div className="mx-auto flex h-full flex-col justify-between pt-[100px] lg:pt-[157px]">
        <div className="mx-auto w-full px-5">
          <div className="mb-[60px] space-y-10 text-center">
            <h1 className="blockH2 font-medium text-orange">Whoops</h1>
            <p className="richH3 text-dark-grey">
              Looks like something went wrong.
              <br />
              Refresh the page to try again.
            </p>
            <Button onClick={handleRefresh} size="xl">
              Refresh Page
            </Button>
            <a
              href="/"
              className="block text-[14px] text-dark-grey underline hover:text-orange"
            >
              Go to the Goodnature homepage
            </a>
          </div>
        </div>
        <div className="h-auto w-full">
          <img
            src="/images/rock-bird.jpg"
            alt="Bird on a rock"
            className="mx-auto h-full w-full"
          />
        </div>
      </div>
    </div>
  );
};
